module.exports = __webpack_public_path__ + "media/images/icon-info-8cbd7b80edcb2dc76df6b6ae83288341.svg";